export type Navegador = "chrome" | "edge" | "firefox" | "safari" | "outros"

export const getNavegador = (): Navegador => {
    if (typeof navigator === "undefined") return "outros"
    const ua = navigator.userAgent.toLowerCase()
    if (ua.includes("edg/")) return "edge"
    if (ua.includes("chrome") && !ua.includes("edg")) return "chrome"
    if (ua.includes("firefox")) return "firefox"
    if (ua.includes("safari") && !ua.includes("chrome")) return "safari"
    return "outros"
}

export const isSmartphone = (): boolean => {
    if (typeof navigator === "undefined") return false
    const ua = navigator.userAgent.toLowerCase()
    return /android|webos|iphone|ipod|blackberry|iemobile|opera mini|mobile|mobile safari/i.test(ua)
}
